import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    genderMale: { civility: { val: "M." }, gender: { val: "M" } },
    genderFemale: { civility: { val: "Mme" }, gender: { val: "F" } },
    daysOfWeek: {
        monday: { val: "lundi" },
        tuesday: { val: "mardi" },
        wednesday: { val: "mercredi" },
        thursday: { val: "jeudi" },
        friday: { val: "vendredi" },
        saturday: { val: "samedi" },
        sunday: { val: "dimanche" }
    }
};

export type _I18nUser = typeof _fr;

const _en: _I18nUser = {
    genderMale: { civility: { val: "Mister" }, gender: { val: "M" } },
    genderFemale: { civility: { val: "Miss" }, gender: { val: "F" } },
    daysOfWeek: {
        monday: { val: "monday" },
        tuesday: { val: "tuesday" },
        wednesday: { val: "wednesday" },
        thursday: { val: "thursday" },
        friday: { val: "friday" },
        saturday: { val: "saturday" },
        sunday: { val: "saturday" }
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nUser(lang?: string): _I18nUser {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}